import * as Yup from 'yup';

export default Yup.object().shape({
  counselorsIds: Yup.array().required('SCHEMA_ERRORS.COUNSELORS_IS_REQUIRED')
});
